<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('keywords')" :class="{active: currentReport === 'keywords'}">
            <span>{{ $t('lang.menu.search.organic.keywords') }}</span>
        </a>
        <a :href="getLink('lostkeywords')" :class="{active: currentReport === 'lostkeywords'}">
            <span>{{ $t('lang.menu.search.organic.lostkeywords') }}</span>
        </a>
        <a :href="getLink('sitepages')" :class="{active: currentReport === 'sitepages'}">
            <span>{{ $t('lang.menu.search.organic.sitepages') }}</span>
        </a>
        <a :href="getLink('lostpages')" :class="{active: currentReport === 'lostpages'}">
            <span>{{ $t('lang.menu.search.organic.lostpages') }}</span>
        </a>
        <a v-if="hasTree" :href="getLink('treepages')" :class="{active: currentReport === 'treepages'}">
            <span>{{ $t('lang.menu.search.organic.treepages') }}</span>
        </a>
        <a :href="getLink('concurents')" :class="{active: currentReport === 'concurents'}">
            <span>{{ $t('lang.menu.search.organic.concurents') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Submenu from "../mixins/Submenu";

export default {
    name: "MenuSubmenuOrganic",
    mixins: [Submenu],
    props: {
        domain: {
            type: String,
            required: true,
        },
        hasTree: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            listenerId: Listeners.TOP_MENU_ORGANIC_HOVER,
        };
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
